import React from "react";

import cx from "classnames";

import styles from "./Grid.scss";

interface GridItemProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Values 1-24 in our 24-column grid
   */
  width?: number;
  /**
   * Values 1-24 in our 24-column grid. Overrides width.
   */
  xs?: number;
  /**
   * Values 1-24 in our 24-column grid. Overrides width, xs on screens >= 601px.
   */
  sm?: number;
  /**
   * Values 1-24 in our 24-column grid. Overrides width, xs, sm on screens >= 769px.
   */
  md?: number;
  /**
   * Values 1-24 in our 24-column grid. Overrides width, xs, sm, md on screens >= 913px.
   */
  lg?: number;
  /**
   * Values 1-24 in our 24-column grid. Overrides width, xs, sm, md on screens >= 1239px.
   */
  xl?: number;
  /**
   * Values 1-24 in our 24-column grid. Adds empty columns before.
   */
  xsOffset?: number;
  /**
   * Values 1-24 in our 24-column grid. Adds empty columns before.
   */
  smOffset?: number;
  /**
   * Values 1-24 in our 24-column grid. Adds empty columns before.
   */
  mdOffset?: number;
  /**
   * Values 1-24 in our 24-column grid. Adds empty columns before.
   */
  lgOffset?: number;
  /**
   * Values 1-24 in our 24-column grid. Adds empty columns before.
   */
  xlOffset?: number;
}

export function GridItem({
  width,
  xs,
  sm,
  md,
  lg,
  xl,
  xsOffset,
  smOffset,
  mdOffset,
  lgOffset,
  xlOffset,
  ...divProps
}: GridItemProps) {
  const gridClass = cx(styles.gridItem, divProps.className, styles.col, {
    [styles[`col-${width}`]]: Boolean(styles[`col-${width}`]),
    [styles[`col-xs-${xs}`]]: Boolean(styles[`col-xs-${xs}`]),
    [styles[`col-sm-${sm}`]]: Boolean(styles[`col-sm-${sm}`]),
    [styles[`col-md-${md}`]]: Boolean(styles[`col-md-${md}`]),
    [styles[`col-lg-${lg}`]]: Boolean(styles[`col-lg-${lg}`]),
    [styles[`col-xl-${xl}`]]: Boolean(styles[`col-xl-${xl}`]),
    // Offsets
    [styles[`col-xs-offset-${xsOffset}`]]: Boolean(
      styles[`col-xs-offset-${xsOffset}`]
    ),
    [styles[`col-sm-offset-${smOffset}`]]: Boolean(
      styles[`col-sm-offset-${smOffset}`]
    ),
    [styles[`col-md-offset-${mdOffset}`]]: Boolean(
      styles[`col-md-offset-${mdOffset}`]
    ),
    [styles[`col-lg-offset-${lgOffset}`]]: Boolean(
      styles[`col-lg-offset-${lgOffset}`]
    ),
    [styles[`col-xl-offset-${xlOffset}`]]: Boolean(
      styles[`col-xl-offset-${xlOffset}`]
    ),
  });

  divProps.className = gridClass;

  return <div {...divProps} />;
}
